// extracted by mini-css-extract-plugin
export default {"item":"style_item__mWTaP","arrow":"style_arrow__s8mjC","expandButton":"style_expandButton__TMi-8"};